import React from 'react';
import LivePriceBadge from './LivePriceBadge';

export default function SymbolWithLivePrice({ symbol, price, className = '' }) {
  const cls = className ? `symbol-with-live-price ${className}` : 'symbol-with-live-price';
  return (
    <span className={cls}>
      <span className="symbol-with-live-price__symbol">{symbol}</span>
      <LivePriceBadge price={price} />
    </span>
  );
}
